import '@/App.css';
import './i18n';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import SmoothScroll from './components/SmoothScroll';
import Header from './components/Header';
import Footer from './components/Footer';
import { Toaster } from './components/ui/sonner';
import { SiteSettingsProvider, useSiteSettings } from './hooks/useSiteSettings';
import { useFontCatalog } from './hooks/useFontCatalog';
import Admin from './pages/Admin';
import AccountAuth from './pages/AccountAuth';
import AccountDashboard from './pages/AccountDashboard';
import DynamicPage from './pages/DynamicPage';
import Login from './pages/Login';
import CustomerProtectedRoute from './components/CustomerProtectedRoute';
import ProtectedRoute from './components/ProtectedRoute';
import { detailRoutes, dynamicPageRoutes, extraDynamicRoutes } from './routes/publicRoutes';
import { useSiteTheme } from './hooks/useSiteTheme';

function App() {
  return (
    <SiteSettingsProvider>
      <AppShell />
    </SiteSettingsProvider>
  );
}

function AppShell() {
  const { settings } = useSiteSettings();
  useFontCatalog();
  useSiteTheme(settings);

  return (
    <div className="App">
      <SmoothScroll>
        <BrowserRouter>
          <div className="min-h-screen flex flex-col">
            <Header />
            <div className="noise" />
            <main className="flex-1">
              <Routes>
                {dynamicPageRoutes.map((route) => (
                  <Route key={route.path} path={route.path} element={<DynamicPage slugOverride={route.slugOverride} />} />
                ))}
                {detailRoutes.map((route) => {
                  const Component = route.element;
                  return <Route key={route.path} path={route.path} element={<Component />} />;
                })}
                {extraDynamicRoutes.map((route) => {
                  const Component = route.element;
                  return <Route key={route.path} path={route.path} element={<Component />} />;
                })}
                <Route path="/login" element={<Login />} />
                <Route path="/account/auth" element={<AccountAuth />} />
                <Route
                  path="/account"
                  element={
                    <CustomerProtectedRoute>
                      <AccountDashboard />
                    </CustomerProtectedRoute>
                  }
                />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute>
                      <Admin />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </main>
            <Footer />
            <Toaster />
          </div>
        </BrowserRouter>
      </SmoothScroll>
    </div>
  );
}

export default App;
